"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexId = exports.quoteString = exports.escapeString = void 0;
function escapeString(str) {
    return str.replace(/(\\|")/g, '\\$1');
}
exports.escapeString = escapeString;
function quoteString(str) {
    return `"${escapeString(str)}"`;
}
exports.quoteString = quoteString;
const dec2hex = (dec) => ('0' + dec.toString(16)).substr(-2);
function hexId(length = 12) {
    var arr = new Uint8Array(length / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join('');
}
exports.hexId = hexId;
